var _defs, _line, _path, _path2, _path3, _path4, _path5, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusinessDealHandshake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "business-deal-handshake") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 20.29,
    y1: 14.34,
    x2: 15.13,
    y2: 15.326
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.416,8.478,10.948,9.624a1.151,1.151,0,0,1-1.405-.611,1.164,1.164,0,0,1,.529-1.53l3.359-1.689a2.343,2.343,0,0,1,1.861-.108l4.973,1.819"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.685,14.348H6.13l3.512,3.936A1.342,1.342,0,0,0,12,17.408v-.615l.175.07a1.656,1.656,0,0,0,2.271-1.537h.489a1.468,1.468,0,0,0,1.174-2.348L12.97,8.956"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.583,7.225l-.358-.295A2.1,2.1,0,0,0,8.98,6.521a2.081,2.081,0,0,0-.779.151L3.75,8.452"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.75,6.75h2a.961.961,0,0,1,1,.916v6.417a.962.962,0,0,1-1,.917h-2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.25,15h-2a.962.962,0,0,1-1-.917V7.666a.961.961,0,0,1,1-.916h2"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 12,
    y1: 16.793,
    x2: 11.022,
    y2: 15.815
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 14.446,
    y1: 15.326,
    x2: 12.978,
    y2: 13.858
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessDealHandshake);
export default __webpack_public_path__ + "static/media/business-deal-handshake.c23a7212.svg";
export { ForwardRef as ReactComponent };